(() => {
  const calculatorSelector = '[data-vintoop-shipping-calculator]';
  const dataSelector = '[data-vintoop-shipping-rate-data]';

  function formatUsd(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  function getRateZone(data, country, state) {
    if (country !== 'US') return data.countries[country];
    return data.usPriorityStates.includes(state) ? 'UPS-US-NYNJ' : 'UPS-US-OTHER';
  }

  function showResult(result, state, content) {
    result.dataset.state = state;
    result.innerHTML = content;
    result.hidden = false;
    result.focus({ preventScroll: true });
  }

  function initCalculator(calculator, data) {
    const form = calculator.querySelector('form');
    const countryInput = form.elements.country;
    const stateInput = form.elements.state;
    const weightInput = form.elements.weight;
    const stateField = calculator.querySelector('[data-vintoop-shipping-state]');
    const result = calculator.querySelector('[data-vintoop-shipping-result]');

    countryInput.addEventListener('change', () => {
      const isUnitedStates = countryInput.value === 'US';
      stateField.hidden = !isUnitedStates;
      stateInput.required = isUnitedStates;
      if (!isUnitedStates) stateInput.value = '';
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const country = countryInput.value;
      const state = stateInput.value;
      const weight = Number.parseFloat(weightInput.value);

      if (!country) {
        showResult(result, 'error', '<p class="vy-shipping__calculator-result-title">Select a delivery country or region to continue.</p>');
        countryInput.focus();
        return;
      }

      if (country === 'US' && !state) {
        showResult(result, 'error', '<p class="vy-shipping__calculator-result-title">Select a US state to continue.</p>');
        stateInput.focus();
        return;
      }

      if (!Number.isFinite(weight) || weight <= 0) {
        showResult(result, 'error', '<p class="vy-shipping__calculator-result-title">Enter a total order weight greater than 0 kg.</p>');
        weightInput.focus();
        return;
      }

      const chargeableWeight = Math.ceil(weight);
      if (chargeableWeight > 20) {
        showResult(
          result,
          'quote',
          '<p class="vy-shipping__calculator-result-title">Manual freight quote required</p><p class="vy-shipping__calculator-result-meta">Orders above 20 kg are not covered by the online rate table. Please contact us for a freight quote.</p>'
        );
        return;
      }

      const rateCode = getRateZone(data, country, state);
      const zone = data.zones[rateCode];
      if (!zone) {
        showResult(
          result,
          'quote',
          '<p class="vy-shipping__calculator-result-title">Shipping quote required</p><p class="vy-shipping__calculator-result-meta">We do not currently have a published manual rate for this destination. Please contact us for a shipping quote.</p>'
        );
        return;
      }

      const rate = zone.rates[chargeableWeight - 1];
      showResult(
        result,
        'success',
        `<p class="vy-shipping__calculator-result-title">Estimated shipping</p><p class="vy-shipping__calculator-result-rate">${formatUsd(rate)} USD</p><p class="vy-shipping__calculator-result-meta">${zone.label} &middot; Charged at ${chargeableWeight} kg for a ${weight.toFixed(2)} kg order.</p>`
      );
    });
  }

  function initAll() {
    const dataElement = document.querySelector(dataSelector);
    if (!dataElement) return;

    let data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    document.querySelectorAll(calculatorSelector).forEach((calculator) => {
      if (calculator.dataset.shippingCalculatorReady === 'true') return;
      calculator.dataset.shippingCalculatorReady = 'true';
      initCalculator(calculator, data);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
